import get from 'lodash/get'
import { STATE_KEY } from 'reducers/presenterReducers'

export const getPresenterMode = state => get(state, `[${STATE_KEY}].on`, false)
